<template>
        <div>
                <el-button type="primary"
                        icon="el-icon-plus"
                        size="small"
                        @click="openDialog('add')"
                >新 增</el-button>
                <el-dialog
                        :title="title"
                        width="65%"
                        :bottom="0"
                        top="60px"
                        append-to-body
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"
                        class="planManagement-addForm"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{title}}
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                
                        </div>
                        <el-divider></el-divider>
                </template>
                
                <div :style="'max-height:'+ dialogBodyHight + 'px;overflow:scroll;'">
                        <avue-form ref="form"  v-model="form" v-if="dialogVisible"  :option="option">
                                <template slot="taskId">
                                        <el-select v-model="form.taskId" :disabled="viewType || editType" clearable placeholder="请选择 任务名称">
                                                <el-option 
                                                        v-for="item in taskList"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id"
                                                >

                                                </el-option>
                                        </el-select>
                                </template>
                                <template slot="standardId">
                                        <el-select v-model="form.standardId" :disabled="viewType || editType || standardIdDisabled" clearable placeholder="请选择 标准名称" >
                                                <el-option 
                                                        v-for="item in standardIdList"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id"
                                                >

                                                </el-option>
                                        </el-select>
                                </template>
                                <template slot="fileAttach" >
                                        <vUpload message="支持word\pdf\excel\照片格式  数量不超过10 大小不超过5M" 
                                        :types="['doc','docx','xlsx','xls','pdf','jpg','png']" 
                                        :max="5242880" :limit="10" 
                                        :fileList.sync="form.fileAttach" :disabled="viewType"></vUpload>
                                </template>
                                <template slot="contractId">
                                        <el-button size="small"  @click="addConstract" :disabled="viewType || contractIdDisabled" type="primary">
                                                关联合同
                                        </el-button>
                                </template>
                        </avue-form>
                </div>
                <template slot="footer" v-if="!viewType">
                        <el-divider></el-divider>
                        <div>
                              <el-button icon="el-icon-circle-plus-outline" @click="submitAssessRecord" size="small" type="primary">{{ title=="新 增"?'保 存':'修 改' }}</el-button>  
                              <el-button icon="el-icon-circle-close" style="margin-right:10px" size="small" @click="handleClose(false)">取 消</el-button>
                        </div>
                </template>
                
                </el-dialog>
                
                <choiceContract ref="choiceContract"  :projectId.sync='this.form.projectId'  @getConstract="getContract"></choiceContract>
        </div>
</template>

<script>
import {submitAssessRecord,getDetail,getStandardByCondition,assessTaskList,getStandardByTaskId} from "@/api/crmedical/examine/examinereportrectify";
import choiceContract from '@/components/choiceContract/choiceDeviceContractv2';
import { getStore } from '@/util/store';
  import vUpload from "@/views/components/v-upload";
export default {
        props:{
                projectId:{
                        type:String,
                        default:''
                }
        },
        components:{
                choiceContract,vUpload
        },
        data(){
                return{
                        standardIdDisabled:false,
                        contractIdDisabled:false,
                        dialogFull:false,
                        viewType:false,
                        editType:false,
                        dialogBodyHight:0,//弹窗bidy高度
                        title:"新增",
                        dialogVisible:false,
                        loading:false,
                        form:{
                                fileAttach:[],
                        },
                        detail:{},
                        taskList:[],
                        standardIdList:[],
                        option:{
                                size:'small',
                                menuPosition:'right',
                                emptyBtn:false,
                                submitIcon:'el-icon-circle-plus-outline',
                                submitText: '保 存',
                                labelWidth:120,
                                submitBtn:false,
                                column:[
                                        {
                                                label: "项目名称",
                                                prop: "projectId",
                                                type: 'tree',
                                                span:8,
                                                cascaderItem: ['objectType'],
                                                searchClearable:false,
                                                editDisabled:true,
                                                dicData:getStore({name: 'projectList'}),
                                                props: { label: 'name', value: 'id' },
                                                searchPlaceholder:"请选择 项目名称",
                                                rules: [{
                                                required: true,
                                                message: "请选择项目名称",
                                                trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "整改对象",
                                                prop: "objectType",
                                                type: "select",
                                                span:8,
                                                searchPlaceholder:"请选择 整改对象",
                                                dicUrl: "/api/v4ward/projectDict/dictionary?code=project_examine_service_type&projectId={{key}}",
                                                props: {
                                                        label: "dictValue",
                                                        value: "dictKey",
                                                },
                                                rules: [{
                                                        required: true,
                                                        message: "请选择整改对象",
                                                        trigger: "blur"
                                                }]
                                        },
                                        {
                                                label: "任务名称",
                                                type:"select",
                                                span:8,
                                                formslot:true,
                                                display:false,
                                                prop: "taskId",
                                                props:{
                                                        label:"name",
                                                        value:"standardId"
                                                },
                                        },
                                        {
                                                label: "任务名称",
                                                type:"select",
                                                span:8,
                                                display:false,
                                                disabled:true,
                                                prop: "taskName",
                                                props:{
                                                        label:"name",
                                                        value:"standardId"
                                                },
                                        },
                                        {
                                                label: "标准名称",
                                                span: 8,
                                                prop: "standardId",
                                                type:"select",
                                                formslot:true,
                                                
                                               
                                        },
                                        {
                                                label: "关联合同",
                                                disabled:true,
                                                span: 8,
                                                formslot:true,
                                                prop: "contractId",
                                                searchPlaceholder:"请输入 关联合同",
                                        },
                                        {
                                                label: "合同名称",
                                                span: 8,
                                                disabled:true,
                                                prop: "contractName",
                                                searchPlaceholder:"请输入 合同名称",
                                        },
                                        {
                                                label: "整改要求",
                                                span: 24,
                                                type:"textarea",
                                                prop: "demand",
                                                showWordLimit:true,
                                                maxlength:200,
                                                rules: [{
                                                        required: true,
                                                        message: "请选择 整改要求",
                                                        trigger: "change"
                                                }]
                                                
                                        },
                                        {
                                                label: "责任人",
                                                span: 16,
                                                maxlength:20,
                                                showWordLimit:true,
                                                prop: "responsibles",
                                                rules: [{
                                                        required: true,
                                                        message: "请输入  责任人",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "要求完成日期",
                                                span: 8,
                                                prop: "requiredEndDate",
                                                type:'date',
                                                format: 'yyyy-MM-dd',
                                                valueFormat: 'yyyy-MM-dd',
                                                // pickerOptions: {
                                                //         disabledDate(time) {
                                                //                 return time.getTime() < Date.now() - 8.64e7;  //如果没有后面的-8.64e7就是不可以选择今天的 
                                                //         }
                                                // },
                                                rules: [{
                                                        required: true,
                                                        message: "请选择 要求完成日期",
                                                        trigger: "change"
                                                }]
                                                
                                        },
                                        {
                                                label: "整改进度",
                                                span: 8,
                                                row:true,
                                                type:"select",
                                                valueType:"string",
                                                dataType:"string",
                                                dicUrl:"/api/blade-system/dict/dictionary?code=examine_rectify_degree_status",
                                                props:{
                                                        label:"dictValue",
                                                        value:"dictKey"
                                                },
                                                prop: "degreeStatus",
                                                rules: [{
                                                        required: true,
                                                        message: "请选择 整改进度",
                                                        trigger: "change"
                                                }]
                                                
                                        },
                                        {
                                                label: "完成情况",
                                                span: 24,
                                                type:"textarea",
                                                prop: "completion",
                                                showWordLimit:true,
                                                maxlength:200,
                                                
                                        },
                                        {
                                                label: "验收人",
                                                span: 16,
                                                maxlength:20,
                                                showWordLimit:true,
                                                prop: "acceptors",
                                                
                                        },
                                        {
                                                label: "验收日期",
                                                span: 8,
                                                type:'date',
                                                format: 'yyyy-MM-dd',
                                                valueFormat: 'yyyy-MM-dd',
                                                prop: "acceptDate",
                                                // pickerOptions: {
                                                //         disabledDate(time) {
                                                //                 return time.getTime() < Date.now() - 8.64e7;  //如果没有后面的-8.64e7就是不可以选择今天的 
                                                //         }
                                                // },
                                                
                                        },
                                        {
                                                label: '附件上传',
                                                prop: 'fileAttach',
                                                formslot: true,
                                                disable: false,
                                                hide: true,
                                                span: 24,
                                        },
                                ]
                                
                        }
                }
        },
        watch:{
                "form.projectId"(val){
                        console.log(val)
                        this.assessTaskList();
                        this.getStandardByCondition();
                },
                "form.objectType"(val){
                        console.log(val)
                        this.assessTaskList();
                        this.getStandardByCondition();
                },
                "form.taskId"(val){
                        if(val){
                                this.standardIdDisabled = true;
                                if(!this.viewType  && !this.editType){
                                        this.form.standardId = ""
                                        // let standardId =  ""
                                        this.taskList.forEach(ele=>{
                                                if(ele.id == val){
                                                        // standardId = ele.standardId;
                                                        this.form.taskName = ele.name;
                                                }
                                        })
                                        // this.form.standardId = standardId;
                                        
                                        
                                }

                                this.getStandardByTaskId(val)
                                // this.getStandardByCondition(val);
                                
                                
                        }else{
                                this.form.taskName="";
                                this.form.standardId = "";
                               
                                this.standardIdDisabled = false;
                        }
                },
                "form.standardId"(val){
                        if(val){
                                this.contractIdDisabled = true;

                                this.standardIdList.forEach(ele=>{
                                        if(ele.id == val){
                                                console.log(ele)
                                                this.form.contractId = ele.contractId;
                                                this.form.contractName = ele.contractName;
                                                this.form.standardName = ele.name;
                                        }
                                })

                        }else{
                                
                                this.form.contractId = "";
                                this.form.contractName = "";
                                this.form.standardName = "";
                                this.contractIdDisabled = false;
                        }
                }
        },
        methods:{
                // 获取任务名称下拉框
                assessTaskList(){
                        if(!this.viewType  && !this.editType){
                                this.form.taskId = "";
                                this.form.standardId = "";
                                this.form.contractId = "";
                                this.form.contractName = "";
                        }
                        
                        
                        
                        if(!this.form.projectId && !this.form.objectType){
                                return
                        }

                        let params = {
                                projectId:this.form.projectId,
                                objectType:this.form.objectType,
                        }
                        console.log(121212)
                        assessTaskList(params).then(({data})=>{
                                this.taskList = data
                        })
                },
                // 根据任务id获取标准
                getStandardByTaskId(taskId){
                        getStandardByTaskId({taskId:taskId}).then(res=>{
                                this.standardIdList = res.data;
                                this.form.standardId = this.standardIdList[0]?this.standardIdList[0].id:"";
                                if(!this.viewType  && !this.editType){
                                        this.standardIdList.forEach(ele=>{
                                                if(ele.id ==  this.form.standardId){
                                                        this.form.contractId = ele.contractId;
                                                        this.form.contractName = ele.contractName;
                                                        this.form.standardName = ele.name;
                                                }
                                        })
                                }
                        })
                },
                // 获取标准名称下拉框
                async getStandardByCondition(){
                        if(!this.viewType  && !this.editType){
                                this.form.contractId = "";
                                this.form.contractName = "";
                        }
                        
                        if(!this.form.projectId || !this.form.objectType){
                                return
                        }
                        let params = {
                                projectId:this.form.projectId,
                                objectType:this.form.objectType,
                                id:this.form.standardId,
                        }
                        await getStandardByCondition(params).then(({data})=>{
                                this.standardIdList = data;
                                if(!this.viewType  && !this.editType){
                                        this.standardIdList.forEach(ele=>{
                                                if(ele.id ==  this.form.standardId){
                                                        this.form.contractId = ele.contractId;
                                                        this.form.contractName = ele.contractName;
                                                        this.form.standardName = ele.name;
                                                }
                                        })
                                }
                               
                        })
                        
                },
                
                // 新增或者提交 看有没有id
                submitAssessRecord(){

                        this.$refs.form.validate((valid)=>{
                                if(valid){
                                        this.loading = true;
                                        submitAssessRecord(this.form).then(res=>{
                                                this.$message({
                                                        message: '操作成功！',
                                                        type: 'success'
                                                });
                                                this.dialogVisible = false;
                                                this.$emit('onLoad')
                                                this.loading = false;
                                        }).catch(()=>{
                                                this.loading = false;
                                        })
                                }
                        })
                },
                // 获取合同
                getContract(contract){
                        
                        this.form.contractId = contract.id;
                        this.form.contractName = contract.name;
                        this.form.contractCode = contract.code;
                },
                // 打开添加合同弹窗
                addConstract(){
                        this.$refs.choiceContract.openDialog();
                },
                
                openDialog(type,data){
                        this.loading = true;
                        this.form = {
                                fileAttach:[],
                        }
                        let contractIdColumn = this.findObject(this.option.column,'contractId');
                        let taskIdColumn = this.findObject(this.option.column,'taskId');
                        let taskNameColumn = this.findObject(this.option.column,'taskName');
                        if(type=='add'){
                                contractIdColumn.display = true;
                                this.form.projectId = this.projectId;
                                this.title = "新 增";
                                this.viewType = false;
                                this.editType = false;
                                this.option.column[0].disabled = false;
                                this.option.column[1].disabled = false;
                                this.option.disabled = false;
                                taskIdColumn.display = true;
                                taskNameColumn.display = false;
                                this.initData();
                                this.loading = false;
                        }else if(type=='view'){
                                this.title = "查 看";
                                this.viewType = true;
                                this.option.disabled = true;
                                contractIdColumn.display = false;
                                taskIdColumn.display = false;
                                taskNameColumn.display = true;
                                this.initData(data);
                        }else if(type=='edit'){
                                contractIdColumn.display = false;
                                this.viewType = false;
                                this.editType = true;
                                this.option.column[0].disabled = true;
                                this.option.column[1].disabled = true;
                                this.option.disabled = false;
                                taskIdColumn.display = false;
                                taskNameColumn.display = true;
                                this.title = "编 辑";
                                this.initData(data);
                        }
                        this.dialogVisible = true;
                },
                async initData(data){
                        
                        if(!data)return;
                        await getDetail({id:data.id}).then(res=>{
                                this.form = res.data;
                                this.form.objectType = String(this.form.objectType);
                                this.form.degreeStatus = String(this.form.degreeStatus);
                                this.detail = res.data;
                                this.loading = false;
                        }).catch(()=>{
                                this.loading = false;
                        })
                        this.form.taskId = this.detail.taskId;
                        this.form.taskName = this.detail.taskName;
                },
                // 弹窗关闭前
                handleClose(done){
                        let self = this;
                        if(this.viewType){
                                self.dialogVisible = false;
                                return;
                        }
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                
                                        self.dialogVisible = false;
                                if(done){
                                        // this.selectTimeFlag = false;

                                }else{
                                        // this.selectTimeFlag = false;
                                }
                                        // done();
                        })
                        .catch(()=> {
                                
                        });
                },
        },
        mounted(){
                let bodyHight = document.body.clientHeight;
                this.dialogBodyHight = bodyHight - 320;

        }
}
</script>

<style lang="scss">
.el-table .cell{
        white-space:inherit;
}
</style>